module.exports = __webpack_public_path__ + "static/media/lock.fcebe3f8.svg";